module.exports = __webpack_public_path__ + "static/media/slack.37780cc2.svg";